import { render, staticRenderFns } from "./PageClientList.vue?vue&type=template&id=b67c4144"
import script from "./PageClientList.vue?vue&type=script&lang=js"
export * from "./PageClientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports